const development_tenant = {
    notification: 'Ești în modul de dezvoltare',
};
export default Object.freeze(development_tenant);
